import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=4730d060&scoped=true&lang=true&"
import script from "./ResultPage.vue?vue&type=script&lang=js&"
export * from "./ResultPage.vue?vue&type=script&lang=js&"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=4730d060&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730d060",
  null
  
)

export default component.exports